module.exports = __webpack_public_path__ + "static/media/admin-chip.9a0ec774.png";